module.exports = __webpack_public_path__ + "img/home-hero-enhanced.256a1b95.png";